module.exports = __webpack_public_path__ + "media/images/icon-search@2x-40fb0c4ae143a23043ee99f2e4300d5c.png";